import React from 'react';
import Button from '../../Butten/Button';
import Pinkbtn from '../../Butten/Pinkbtn';

const Decision = ({ _field, _index, index, handleInsideInput }) => {
  return (
    <>
      <div
        className="main-dec m-0 p-0 rounded-b-xl"
        style={{ backgroundColor: '#eceff4' }}
      >
        <div className="text-content ml-1">
          <input
            placeholder="Decision Name"
            name="name"
            value={_field.name}
            onChange={e => handleInsideInput(e, index, _index)}
          />
        </div>
        <div className="text-content">
          <p className="font-medium  p-2">Text Content</p>
          <textarea
            className="w-[42vw] mx-2 rounded-md outline-0"
            placeholder="Enter text here "
            name={'textContent'}
            value={_field.textContent}
            onChange={e => handleInsideInput(e, index, _index)}
            rows="auto"
          ></textarea>
        </div>
        <div className="text-content">
          <p className="font-medium m-2">Link</p>
          <input
            className="w-[42vw] mx-2 rounded-md outline-0 "
            type="text"
            name={'link'}
            value={_field.link}
            onChange={e => handleInsideInput(e, index, _index)}
            placeholder="paste the url here"
          />
        </div>
        <div className="btns flex justify-between  w-[44vw]">
          <div className="dot" style={{ color: '#eceff4' }}>
            .
          </div>
          <div className="btn flex">
            {/* <Button btntext="cancle" /> */}
            {/* <Pinkbtn pbtntext="save"/> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Decision;
